export default __webpack_public_path__ + "static/media/menuA.b7cd5053.svg";